<mat-toolbar class="sticky top-0 z-1 space-x-2 shadow-sm dark:border-b">
  <button type="button" aria-label="Toggle sidenav" matIconButton (click)="toggleSidenav.emit()">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <span class="flex-1"></span>

  <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
    <base-fullscreen class="hidden md:block"></base-fullscreen>
    <theme-switcher></theme-switcher>
    <user></user>
  </div>
</mat-toolbar>
